const IPV4_PATTERN =
  /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}$/;

const IPV6_PATTERN =
  /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;

const HTTP_PATTERN = /^https?:$/;

// Dot-separated labels of letters, digits, and hyphens, e.g. an AWS ELB's
// generated hostname. Deliberately permissive (no length limits or
// leading/trailing-hyphen checks) — only meant to rule out non-hostnames.
const HOSTNAME_PATTERN = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*$/;

export const isValidHostname = (value: string | undefined): boolean =>
  !!value && HOSTNAME_PATTERN.test(value);

export type LoadBalancerAddressKind = "hostname" | "ipv4" | "ipv6";

/** Classifies a LoadBalancer address so instructions can name the exact DNS
 * record type it needs (A, AAAA, or CNAME) — e.g. AWS ELBs hand out a
 * hostname rather than a static IP, unlike GCP/Azure. */
export const classifyLoadBalancerAddress = (
  value: string | undefined
): LoadBalancerAddressKind | undefined => {
  if (!value) return undefined;
  if (IPV4_PATTERN.test(value)) return "ipv4";
  if (IPV6_PATTERN.test(value)) return "ipv6";
  if (HOSTNAME_PATTERN.test(value)) return "hostname";
  return undefined;
};

export type DnsRecordType = "A" | "AAAA" | "CNAME";

/** DNS record type for a classified LoadBalancer address — shared so
 * selfHosted instructions and p0Hosted DNS creation agree. */
export const DNS_RECORD_TYPE_BY_KIND: Record<
  LoadBalancerAddressKind,
  DnsRecordType
> = {
  ipv4: "A",
  ipv6: "AAAA",
  hostname: "CNAME",
};

export const isHttpUrl = (value: string | undefined): boolean => {
  if (!value) return false;
  try {
    return HTTP_PATTERN.test(new URL(value).protocol);
  } catch {
    return false;
  }
};
